import { FontSource, FontType } from "@fhc/shared/constants";
import { Clear, DoNotDisturb, FilePresent } from "@mui/icons-material";
import { useState } from "react";
import Button from "shared/components/Button";
import FileUpload from "shared/components/FileUpload";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { getFileDataURL } from "utils";

function FontPicker({ label, themeVar, themeColors, setThemeColors, customFontFile, setCustomFontFile }) {
    const [error, setError] = useState(null);

    const fontTypes = [
        { label: "serif", value: FontType.SERIF },
        { label: "sans-serif", value: FontType.SANS_SERIF },
        { label: "monospace", value: FontType.MONOSPACE },
    ].map((option) => ({ label: option.label, value: option }));

    const fontSources = [
        { label: "N/A", value: FontSource.NONE },
        { label: "File", value: FontSource.FILE },
        { label: "Google Fonts", value: FontSource.GOOGLE_FONT },
    ].map((option) => ({ label: option.label, value: option }));

    return (
        <>
            <span className="paragraph-6-regular text-[#000000de]">{label}</span>
            <div className="grid gap-1">
            <span>Source</span>
            <Select
                placeholder="Source Type"
                options={fontSources}
                value={fontSources.find((option) => option.value.value === themeColors[themeVar].source)}
                onChange={(value) => {
                    setThemeColors((theme) => ({
                        ...theme,
                        [themeVar]: {
                            ...theme[themeVar],
                            source: value.value,
                        },
                    }));
                }}
            />
            <div className="flex gap-1">
                <div className="flex flex-col flex-grow">
                <span>Family</span>
                <Input
                    type="text"
                    placeholder="Family"
                    value={themeColors[themeVar].name}
                    onChange={(value) => {
                        setThemeColors((theme) => ({
                            ...theme,
                            [themeVar]: {
                                ...theme[themeVar],
                                name: value,
                            },
                        }));
                    }}
                /></div>
                <div className="flex flex-col w-40">
                    <span>Type</span>
                <Select
                    placeholder="Type"
                    options={fontTypes}
                    value={fontTypes.find((option) => option.value.value === themeColors[themeVar].type)}
                    onChange={(value) => {
                        setThemeColors((theme) => ({
                            ...theme,
                            [themeVar]: {
                                ...theme[themeVar],
                                type: value.value,
                            },
                        }));
                    }}
                />
                </div>
            </div>
            {themeColors[themeVar].source === FontSource.FILE && (
                <>
                    <div className="flex justify-between">
                        {themeColors[themeVar].file ? (
                            <>
                                <span>
                                    <FilePresent />
                                    {themeColors[themeVar].file.name}
                                </span>
                                <Button
                                    className="btn-xs"
                                    onClick={() => {
                                        setThemeColors((theme) => ({
                                            ...theme,
                                            [themeVar]: {
                                                ...theme[themeVar],
                                                file: null,
                                            },
                                        }));
                                        setCustomFontFile(null);
                                    }}
                                >
                                    <Clear />
                                </Button>
                            </>
                        ) : (
                            <span>
                                <DoNotDisturb />
                                No file (Built-in)
                            </span>
                        )}
                    </div>
                    <FileUpload
                    allowedFileTypes={{ woff2: "font/woff2" }}
                        maxFileSizeMib={5}
                        onUpload={(value) => {
                            getFileDataURL(value).then((url) => {
                                setThemeColors((theme) => ({
                                    ...theme,
                                    [themeVar]: {
                                        ...theme[themeVar],
                                        name: value.name.split('.')[0],
                                        file: {
                                            name: value.name,
                                            data: url,
                                        },
                                    },
                                }));
                                setCustomFontFile(value);
                            });
                        }}
                        onError={e => {setError(e[0])}}
                    />
                </>
            )}
            {error && <span style={{
                color: "var(--colors-primary-error-400)"
            }}>{error}</span>}
            </div>
        </>
    );
}

export default FontPicker;
